export default __webpack_public_path__ + "static/media/WCHSS.b20f8bf7.png";